import Enums from '@/config/enums.config';

import SimpleVideo from '@/components/SimpleVideo/SimpleVideo.vue';

export default {
  name: 'AdPop',
  props: {
    adPopConfig: Object
  },
  components: {
    SimpleVideo
  },
  data: function() {
    return {
      Enums
    };
  },
  methods: {
    videoPlayHandler() {
      this.$emit('btn-click', { btnOperation: 'videoPlay' });
    },
    closeBtnClickHandler() {
      this.$emit('btn-click', { btnOperation: 'close' });
    },
    jumpContent(url) {
      this.$emit('btn-click', { btnOperation: 'linkContent', url });
    },
    jumpMore(url) {
      this.$emit('btn-click', { btnOperation: 'linkMore', url });
    },
    pauseVideo() {
      if (this.$refs.adVideo) {
        this.$refs.adVideo.pauseVideo();
      }
    },
    continuePlayVideo() {
      if (this.$refs.adVideo) {
        this.$refs.adVideo.continuePlayVideo();
      }
    }
  }
};
